import { FC } from 'react';
import { ListItem, OrderedList } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';
import Header from 'features/Onboarding/components/Header';
import Page from 'features/Onboarding/legacy/components/Page';
import { OnboardingPageContent } from 'features/Onboarding/pageLayoutStyles';

import locales from './locales';

interface BeneficiariesDocsIntroComponentProps {
  onNavigate: () => void;
}
const BeneficiariesDocsIntroComponent: FC<
  BeneficiariesDocsIntroComponentProps
> = ({ onNavigate }) => (
  <Page backButtonNavigatesBack>
    <OnboardingPageContent>
      <Header description={locales.subtitle} title={locales.title} />

      <Text>{locales.cardIntroduction}</Text>

      <SunshineCard.Group isBoxed={false} marginTop="space-16">
        <SunshineCard alignItems="center" title={locales.step1Title}>
          <SunshineCard.Slot name="aside">
            <SquircleIcon name="team" />
          </SunshineCard.Slot>
        </SunshineCard>

        <SunshineCard alignItems="center" title={locales.step2Title}>
          <SunshineCard.Slot name="aside">
            <SquircleIcon name="mail" />
          </SunshineCard.Slot>
        </SunshineCard>

        <SunshineCard alignItems="center" title={locales.step3Title}>
          <SunshineCard.Slot name="aside">
            <SquircleIcon name="edit-file" />
          </SunshineCard.Slot>

          <SunshineCard.Content>
            <OrderedList>
              {locales.step3Substeps.map((substep, index) => (
                <ListItem key={index}>
                  <SunshineCard.Text>{substep}</SunshineCard.Text>
                </ListItem>
              ))}
            </OrderedList>
          </SunshineCard.Content>
        </SunshineCard>
      </SunshineCard.Group>

      <Button
        alignSelf="start"
        isExpanded
        marginTop="space-24"
        onClick={onNavigate}
      >
        {locales.cta}
      </Button>
    </OnboardingPageContent>
  </Page>
);

export default BeneficiariesDocsIntroComponent;
